var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Welcome to Tadi Tech")]),_c('v-btn',{attrs:{"router":"","to":"new-releases"}},[_vm._v("New Releases")]),_c('v-btn',{attrs:{"router":"","to":"playlists"}},[_vm._v("Reorder Playlists")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }